module.exports = __webpack_public_path__ + "img/queryResultsMFZX.d5987534.png";